<template>
  <div class="chaptersss" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <ul v-for="(item, index) in list" :key="index">
        <div class="tit">{{item.name}}</div>
        <li @click="course_id(items.id,items.relate_type,items.is_study)" v-for="(items, indexs) in item.lesson"
            :key="indexs">
          <div class="t fl">{{index+1}} - {{indexs+1}}&nbsp;&nbsp;&nbsp;&nbsp;{{items.name}}  <span style="font-size: 12px; margin: 0 0 0 10px;" >{{items.lesson_completion}}</span> </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        list: [],
        chaperLists: []
      }
    },
    created () {
      this.getdata()
    },
    methods: {
      getdata () {
        this.$http.post('/apipx/Lesson/chapterinfo', {
          course_id: this.$parent.course_id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          this.list = res.data
          this.chaperList()
        })
      },
      course_id (id, relateType, isStudy) {
        if (relateType === 'live') {
          this.$parent.id = id
          this.chaperList()
          this.$parent.getdata()
        } else {
          if (isStudy === 1) { // 学习完成  可否点击  2 是 1 不是
            this.$parent.id = id
            this.chaperList()
            this.$parent.getdata()
          } else {
            if (this.$parent.info.is_order === 1) { // 按照顺序学习 1 是  2 不是
              if (isStudy === 1) { // 学习完成  可否点击  2 是 1 不是
                this.$parent.id = id
                this.chaperList()
                this.$parent.getdata()
              } else {
                this.$message({
                  duration: '2000',
                  type: 'error',
                  message: '请学习完前面章节'
                })
              }
            } else {
              this.$parent.id = id
              this.chaperList()
              this.$parent.getdata()
            }
          }
        }
      },
      chaperList () {
        let chaperArr = []
        let cha = this.list
        for (let i = 0; i < cha.length; i++) {
          for (let x = 0; x < cha[i].lesson.length; x++) {
            chaperArr.push({
              key: i,
              keys: x,
              val: cha[i].lesson[x].name,
              id: cha[i].lesson[x].id
            })
          }
        }
        this.chaperLists = chaperArr
        this.$emit('chaperTit', chaperArr)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .chaptersss {
    width: 360px;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    .content {
      ul {
        overflow: hidden;

        .tit {
          padding: 0 35px;
        }

        margin: 30px auto 10px;
        font-size: 24px;

        li {
          line-height: 60px;
          padding: 0 35px;
          cursor: pointer;
          font-size: 14px;
          overflow: hidden;

          .student {
            display: none;
            width: 80px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background-color: #ff8484;
            text-align: center;
            border-radius: 10px;
            margin: 10px 0 0 0;
            cursor: pointer;

            &:hover {
              background-color: #ffa8a8;
            }
          }

          &:hover {
            background-color: #fff8f8;
            color: #ff8484;

            .student {
              display: block;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/chapter/chapter.vue